import { render, staticRenderFns } from "./m-product-options-bundle.vue?vue&type=template&id=522abf8a&"
import script from "./m-product-options-bundle.vue?vue&type=script&lang=js&"
export * from "./m-product-options-bundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports